<template>
	<div class="container">
		<div class="main_top">
			<div class="headline">
				<p class="main_title">
					{{ $t('rtr_home.text1') }}<br />
					{{ $t('rtr_home.text2') }}<br />
					{{ $t('rtr_home.text3') }}
				</p>
				<p class="main_text">{{ $t('rtr_home.text4') }}</p>
				<button
					class="button_bg_red"
					@click="$router.push({ name: 'personal-request-send' })"
				>
					{{ $t('rtr_home.button1') }}
				</button>
			</div>
		</div>

		<section>
			<div class="main_content">
				<div class="detail_area">
					<h2 class="title">
						{{ $t('rtr_home.text5') }}<br />
						{{ $t('rtr_home.text6') }}
					</h2>
					<p class="text">
						{{ $t('rtr_home.text7') }}{{ $t('rtr_home.text8') }}
					</p>
					<router-link :to="{ name: 'auth-register' }" class="m_link_type_02">
						{{ $t('rtr_home.text9') }}
						<span class="CIRCLE_ARROW"></span>
					</router-link>
				</div>
				<div class="img_area type_01">
					<img src="@/assets/images/main_bg_01.png" alt="" />
				</div>
			</div>
		</section>

		<section>
			<div class="main_content">
				<div class="detail_area">
					<h2 class="title">
						{{ $t('rtr_home.text10') }}<br />
						{{ $t('rtr_home.text11') }}
					</h2>
					<p class="text">
						{{ $t('rtr_home.text12') }}<br />
						{{ $t('rtr_home.text13') }}
					</p>
					<router-link :to="{ name: 'auth-register' }" class="m_link_type_02">
						{{ $t('rtr_home.text14') }}
						<span class="CIRCLE_ARROW"></span>
					</router-link>
				</div>
				<div class="img_area type_01">
					<img src="@/assets/images/main_bg_02.png" alt="" />
				</div>
			</div>
		</section>

		<section>
			<div class="main_content">
				<div class="detail_area">
					<h2 class="title">
						{{ $t('rtr_home.text15') }}<br />
						{{ $t('rtr_home.text16') }}
					</h2>
					<p class="text">
						{{ $t('rtr_home.text17') }} {{ $t('rtr_home.text18') }}
						{{ $t('rtr_home.text19') }}<br /><br />
						{{ $t('rtr_home.text20') }}<br />
						{{ $t('rtr_home.text21') }}<br />
						{{ $t('rtr_home.text21_1') }}
					</p>
					<router-link
						:to="{ name: 'personal-how-online_shopping' }"
						class="m_link_type_02"
					>
						{{ $t('rtr_home.text22') }}
						<span class="CIRCLE_ARROW"></span>
					</router-link>
				</div>
				<div class="img_area type_02">
					<img src="@/assets/images/main_bg_03.png" alt="" />
					<div class="bubble type_01">
						<p>{{ $t('rtr_home.text23') }}</p>
						<p>{{ $t('rtr_home.text24') }}</p>
					</div>
					<div class="bubble type_02">
						<p>{{ $t('rtr_home.text25') }}</p>
						<p>{{ $t('rtr_home.text26') }}</p>
					</div>
					<div class="bubble type_03">
						<p>{{ $t('rtr_home.text27') }}</p>
						<p>{{ $t('rtr_home.text28') }}</p>
					</div>
				</div>
			</div>
		</section>

		<section class="panel catch tac">
			<h2 class="title fc_white">{{ $t('rtr_home.text29') }}</h2>
			<p class="text fc_white fw_light">
				{{ $t('rtr_home.text30') }}<br />
				{{ $t('rtr_home.text31') }}<br />
				{{ $t('rtr_home.text32') }}
			</p>
			<button
				class="button_bg_red"
				@click="$router.push({ name: 'auth-register' })"
			>
				{{ $t('rtr_home.button2') }}
			</button>
		</section>

		<section class="type_02">
			<div class="main_content">
				<div class="detail_area">
					<div class="detail">
						<h2 class="title">
							{{ $t('rtr_home.text33') }}<br />
							{{ $t('rtr_home.text34') }}
						</h2>
						<p class="text">
							{{ $t('rtr_home.text35') }}<br />
							{{ $t('rtr_home.text36') }}<br />
							{{ $t('rtr_home.text37') }}
						</p>
						<router-link
							:to="{ name: 'business-how-start' }"
							class="m_link_type_02"
						>
							{{ $t('rtr_home.text38') }}
							<span class="CIRCLE_ARROW"></span>
						</router-link>
					</div>
				</div>
				<div class="img_area">
					<img src="@/assets/images/main_bg_04.png" alt="" />
				</div>
			</div>
		</section>

		<section class="type_02">
			<div class="main_content">
				<div class="detail_area">
					<div class="detail">
						<h2 class="title">
							{{ $t('rtr_home.text39') }}
							<br />
							{{ $t('rtr_home.text40') }}
						</h2>
						<p class="text">
							{{ $t('rtr_home.text41') }} {{ $t('rtr_home.text42') }}
						</p>
						<router-link :to="{ name: 'cs' }" class="m_link_type_02">
							{{ $t('rtr_home.text43') }}
							<span class="CIRCLE_ARROW"></span>
						</router-link>
					</div>
				</div>
				<div class="img_area">
					<img src="@/assets/images/main_bg_05.png" alt="" />
				</div>
			</div>
		</section>
	</div>
	<!--	<ModalViewM v-if="modalPopup" @closeModal="modalPopup = false">-->
	<!--		<div class="inner_border">-->
	<!--			<div class="popup_content">-->
	<!--				<div class="logo">-->
	<!--					<img src="@/assets/images/logo.png" alt="logo image" />-->
	<!--				</div>-->
	<!--				<h2>-->
	<!--					{{ $t('popup.title1') }}<br />-->
	<!--					<span class="fc_red">{{ $t('popup.title2') }}</span-->
	<!--					>{{ $t('popup.title3') }}-->
	<!--				</h2>-->
	<!--				<p class="popup_text">-->
	<!--					{{ $t('popup.m_text1') }}<br />-->
	<!--					{{ $t('popup.m_text2') }}-->
	<!--				</p>-->
	<!--				<div class="tar">-->
	<!--					<p class="highlight">{{ $t('popup.m_text3') }}</p>-->
	<!--					<p class="period">-->
	<!--						{{ $t('popup.m_text4') }}<br />~{{ $t('popup.m_text5') }}-->
	<!--					</p>-->
	<!--				</div>-->
	<!--			</div>-->
	<!--		</div>-->
	<!--		<div class="d_flex align_items_center mt_20">-->
	<!--			<div class="d_flex align_items_center mr_10">-->
	<!--				<input type="checkbox" id="off" class="mr_10" v-model="check" />-->
	<!--				<label for="off">{{ $t('button.not_see_today') }}</label>-->
	<!--			</div>-->
	<!--			<a class="btn_close" @click="closePopup">{{ $t('button.close') }}</a>-->
	<!--		</div>-->
	<!--	</ModalViewM>-->
</template>

<script>
import '@/assets/css/popup.css';
import store from '@/store/store';
// import ModalViewM from '@/components/Layout/ModalView.m';
import Cookies from 'js-cookie';

export default {
	name: 'Home',
	// components: { ModalViewM },
	data() {
		return {
			modalPopup: true,
			check: false,
		};
	},
	beforeRouteEnter(to, from, next) {
		if (store.getters['auth/is_logged_in']) {
			next({ name: 'auth-dashboard' });
		} else {
			next();
		}
	},
	methods: {
		closePopup() {
			if (this.check) {
				this.setCookie();
			}
			this.modalPopup = false;
		},
		setCookie() {
			Cookies.set('popup', this.check, { expires: 1 });
		},
	},
	mounted() {
		if (Cookies.get('popup')) {
			this.modalPopup = false;
		}
	},
};
</script>
